const resource = {
    resource_identifier_in_use: 'API識別子 {{indicator}} はすでに使用されています',
    cannot_delete_management_api: 'Logto管理APIを削除できません。',
    cannot_modify_management_api: 'Logto管理APIを変更できません。',
};
export default Object.freeze(resource);
